// Aturan validasi nama & nama perusahaan kontak khusus website internal
// (CRM Kledo, website_id 107471). Sumber tunggal yang dipakai oleh:
// - ContactForm.jsx (sebagai AntD Form rules + filter input)
// - FourthStepSchedule.jsx (gate imperatif saat memilih kontak existing)

export const NAME_MAX = 50;
// Sapaan/singkatan yang dilarang — hanya dicek bila berada di AWAL nama.
// "Pak Abas" → ditolak; "MaPak Abas" → lolos.
export const FORBIDDEN_NAME_PREFIXES = [
  "ibu ",
  "bapak ",
  "pak ",
  "bu ",
  "kak ",
  "sdr ",
  "su ",
  "sm ",
  "csr ",
  "csp ",
  "sd ",
  "sa ",
];
export const NAME_ALLOWED_RE = /^[A-Za-z .']+$/;
// Nama perusahaan: huruf, angka, spasi, dan . - / | &
export const COMPANY_ALLOWED_RE = /^[A-Za-z0-9 .&|/-]+$/;

export const stripName = (e) =>
  e.target.value.replace(/[^A-Za-z .']/g, "").slice(0, NAME_MAX);
export const stripCompany = (e) =>
  e.target.value.replace(/[^A-Za-z0-9 .&|/-]/g, "").slice(0, NAME_MAX);

export const hasLetter = (v) => /[a-zA-Z]/.test(v || "");
export const isAllUpper = (v) => hasLetter(v) && !/[a-z]/.test(v);
export const isAllLower = (v) => hasLetter(v) && !/[A-Z]/.test(v);
export const hasForbiddenSalutation = (v) => {
  const val = (v || "").toLowerCase();
  return FORBIDDEN_NAME_PREFIXES.some((w) => val.startsWith(w));
};
// Bandingkan dua teks (case-insensitive + trim).
export const isSameText = (a, b) =>
  !!a && !!b && String(a).trim().toLowerCase() === String(b).trim().toLowerCase();

export const isInternalNameValid = (v) => {
  const val = v || "";
  return (
    val.length >= 4 &&
    val.length <= NAME_MAX &&
    hasLetter(val) &&
    NAME_ALLOWED_RE.test(val) &&
    !hasForbiddenSalutation(val) &&
    !isAllUpper(val) &&
    !isAllLower(val)
  );
};

// Nama perusahaan bawaan inhouse boleh huruf besar semua (memang begitu nama
// resminya), asal teksnya persis sama dengan data inhouse.
export const getInhouseCompanyNames = (users) =>
  (users || []).flatMap((user) =>
    (user?.companies || []).map((company) => company?.name).filter(Boolean)
  );
export const isInhouseCompany = (v, inhouseCompanies) =>
  !!v && (inhouseCompanies || []).some((name) => name.trim() === v.trim());

export const isInternalCompanyValid = (
  v,
  { required, name, inhouseCompanies } = {}
) => {
  const val = v || "";
  if (!val) return !required;
  if (name && isSameText(val, name)) return false; // tidak boleh sama dgn nama
  return (
    val.length >= 4 &&
    val.length <= NAME_MAX &&
    hasLetter(val) &&
    COMPANY_ALLOWED_RE.test(val) &&
    (!isAllUpper(val) || isInhouseCompany(val, inhouseCompanies)) &&
    !isAllLower(val)
  );
};

// Gate Step 4 (kontak existing): Nama + Nama Perusahaan + Sapaan.
// Pakai name_only (nama murni dari suggestion); fallback ke name.
// inhouseCompanies: nama perusahaan inhouse yang boleh huruf besar semua.
export const isContactValidForInternal = (c, { inhouseCompanies } = {}) =>
  !!c &&
  isInternalNameValid(c.name_only || c.name) &&
  isInternalCompanyValid(c.company, {
    required: true,
    name: c.name_only || c.name,
    inhouseCompanies,
  }) &&
  !!c.salutation_id;
